export const routeVariants = {
  initial: {
    x: 100,
    opacity: 0,
    transition: {
      type: "tween",
      duration: 0.2,
      ease: "easeInOut",
    },
  },
  final: {
    x: 0,
    opacity: 1,
    transition: {
      type: "tween",
      duration: 0.2,
      ease: "easeInOut",
    },
  },
  exit: {
    x: -100,
    opacity: 0,
    transition: {
      type: "tween",
      duration: 0.2,
      ease: "easeInOut",
    },
  },
};

export const guideVariants = {
  initial: {
    width: 0,
    opacity: 0,
    transition: {
      type: "tween",
      duration: 0.2,
      ease: "easeInOut",
    },
  },
  final: {
    width: "initial",
    opacity: 1,
    transition: {
      type: "tween",
      duration: 0.2,
      ease: "easeInOut",
    },
  },
  exit: {
    width: 0,
    opacity: 0,
    transition: {
      type: "tween",
      duration: 0.2,
      ease: "easeInOut",
    },
  },
};

export const opacityVariants = {
  initial: {
    opacity: 0,
    transition: {
      type: "tween",
      duration: 0.2,
      ease: "easeInOut",
    },
  },
  final: {
    opacity: 1,
    transition: {
      type: "tween",
      delay: 0.2,
      duration: 0.2,
      ease: "easeInOut",
    },
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: {
      height: {
        duration: 0,
      },
      opacity: {
        type: "tween",
        duration: 0.2,
        ease: "easeInOut",
      },
    },
  },
};

export const loginVariantsDuration = 0.4;
export const loginVariants = {
  initial: {
    y: "-100vh",
    transition: {
      type: "tween",
      duration: loginVariantsDuration,
      ease: "easeInOut",
    },
  },
  final: {
    y: 0,
    transition: {
      type: "tween",
      duration: loginVariantsDuration,
      ease: "easeInOut",
    },
  },
};
